import { render, staticRenderFns } from "./areaBear.vue?vue&type=template&id=16346ec4&"
import script from "./areaBear.vue?vue&type=script&lang=js&"
export * from "./areaBear.vue?vue&type=script&lang=js&"
import style0 from "./areaBear.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports